import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SiteConfigService } from '../../core/services/core.site-config.service'
import { UserService } from '../../core/services/core.user.service';

import * as _ from 'lodash';

@Component({
  selector: 'gf-thumbnail',
  template: `
    <img
      *ngIf="src"
      [class]="customClass"
      [id]="'thumbnail-mini-' + fileObject.id"
      [alt]="fileObject.fileName"
      [src]="src"
    />
  `,
})
export class ThumbnailComponent implements OnInit {
  @Input() fileObject: any;
  @Input() customClass: string;
  private defaultThumbnailImage = '/core/img/filetypes/256/BLANK.png';
  protected src: SafeUrl | null = null;

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private siteConfigService: SiteConfigService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.src = this.sanitizer.bypassSecurityTrustUrl(
      _.get(this.fileObject, 'thumbnailUrl', this.defaultThumbnailImage)
    );

    const name = _.get(this.fileObject, 'fileName', '');
    const idx = name.lastIndexOf('.');

    // No extension or no session user? Don't thumbnail it.
    if (idx === -1 || !this.userService.hasUser()) {
      return;
    }

    const fileTypes = _.get(this.siteConfigService.getSiteConfig(), 'useThumbnails', []);
    const ext = name.slice(idx + 1);

    if (!_.includes(fileTypes, ext)) {
      return;
    }

    const id = _.get(this.fileObject, 'id', false);
    const fileType = this.fileObject?.fileType ?? null;

    const handler = (res: any) => { 
        this.getResponseData(fileType, res) };

    if (id) {
      const url = `/api/filesystem/${id}/thumbnail`;
      this.http
        .get(url, { responseType: 'arraybuffer', observe: 'response' })
        .subscribe(handler, handler);
    }
  }

  private getResponseData(fileType: string, res: any): void {
    if (_.get(res, 'status', 500) < 400) {
      if (_.get(res, 'body.byteLength', 0) > 0) {
        const blob = new Blob([new Uint8Array(res.body)], { type: fileType });
        const url = URL.createObjectURL(blob);
        const dataUrl: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(url);
        this.src = dataUrl;
      }
    }
  }
}
